<template>

  <v-hover v-slot:default="{ hover }">
    <v-card :class="{'ma-3': true, 'hover': hover}" outlined @click="selectSupplier">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card-title v-text="supplier.contact.name"/>
        </v-col>
      </v-row>
    </v-card>
  </v-hover>

</template>


<script>

  export default {
    props: {
      supplier: null
    },

    data: () => ({
      hover: false
    }),

    methods: {
      selectSupplier() {
        this.$router.push(`/suppliers/${this.supplier.id}`);
      }
    }
  }

</script>


<style scoped>

  .hover {
    cursor: pointer;
    background-color: rgba(0,0,0,.05);
  }

</style>